module.exports = {
          srcSet: __webpack_public_path__ + "bdd7402f14e80ce296723c9dafc9bc7d-86.png"+" 86w",
          images:[ {path: __webpack_public_path__ + "bdd7402f14e80ce296723c9dafc9bc7d-86.png",width: 86,height: 28}],
          src: __webpack_public_path__ + "bdd7402f14e80ce296723c9dafc9bc7d-86.png",
          toString:function(){return __webpack_public_path__ + "bdd7402f14e80ce296723c9dafc9bc7d-86.png"},
          
          width: 86,
          height: 28
        }